export default __webpack_public_path__ + "static/media/people.3f8f4842.svg";